import { EntryValidationStatus } from '@/types/api.generated';
import { logger } from '@/utils/logging';

import { PicksValidationProcessor, ValidateResponse } from '.';
import { useBetslipStore } from '../hooks/use-betslip-store';

type Context = {};

const LOG_TAG = '[Betslip-Validate-Result]';
export class PicksValidateResultProcessor extends PicksValidationProcessor<Context> {
    private successProcessor: PicksValidationProcessor<any> | undefined;
    private errorProcessor: PicksValidationProcessor<any> | undefined;

    process(data: ValidateResponse): void {
        const activeGameMode = useBetslipStore.getState().activeGameMode;
        const result = data.validateEntryOnEntryRules.find(it => it.gameMode === activeGameMode);

        if (!result) {
            logger.warn(LOG_TAG, `No validation result for active ${activeGameMode} game mode found.`);
            return;
        }

        if (result.status === EntryValidationStatus.Success) {
            this.successProcessor?.process(data);
        } else {
            this.errorProcessor?.process(data);
        }
    }

    setNextProcessor(next: PicksValidationProcessor<any>): void {
        this.successProcessor = next;
    }

    withSuccessProcessor(successProcessor: PicksValidationProcessor<any>) {
        this.successProcessor = successProcessor;
        return this;
    }

    withErrorProcessor(errProcessor: PicksValidationProcessor<any>) {
        this.errorProcessor = errProcessor;
        return this;
    }
}
